import { RouteObject } from "react-router-dom";

/**
 * All order tracking iframe routes
 */
export const orderTrackingIframeRoutes: RouteObject[] = [
  // Kuru tracking iframe
  {
    path: "kuru-tracking-iframe",
    lazy: async () => {
      const { KuruTrackingIframeRoot } = await import("./kuru-tracking-iframe");
      return { Component: KuruTrackingIframeRoot };
    },
  },
  {
    path: "jack-archer-tracking-iframe",
    lazy: async () => {
      const { JackArcherTrackingIframeRoot } = await import(
        "./jack-archer-tracking-iframe"
      );
      return { Component: JackArcherTrackingIframeRoot };
    },
  },
  {
    path: "embedded-tracking",
    lazy: async () => {
      const { EmbeddedTrackingRoot } = await import("./embedded-tracking");
      return { Component: EmbeddedTrackingRoot };
    },
  },
];
